module.exports = __webpack_public_path__ + "assets/img/空背景.561f562b.png";